// // import React, { useState } from 'react';
// // import './ContentPage.css';
// // import Footer from './Footer'; // Importar o Footer
// // // import { Link } from 'react-router-dom';
// // import Header from './Header';

// // const ContentPage = () => {
// //   const [searchTerm, setSearchTerm] = useState('');
// //   const [selectedSubject, setSelectedSubject] = useState(null);

// //   const subjects = [
// //     { name: 'Matemática', icon: '/images/math-icon.png' },
// //     { name: 'Português', icon: '/images/portuguese-icon.png' },
// //     { name: 'Ciências', icon: '/images/science-icon.png' },
// //     { name: 'História', icon: '/images/history-icon.png' },
// //     { name: 'Geografia', icon: '/images/geography-icon.png' },
// //   ];

// //   const contentList = {
// //     'Matemática': [
// //       { title: 'Álgebra Básica', class: '9ª Classe', date: '2025-01-10' },
// //       { title: 'Geometria Plana', class: '10ª Classe', date: '2025-02-15' },
// //       { title: 'Trigonometria', class: '11ª Classe', date: '2025-03-20' },
// //     ],
// //     'Português': [
// //       { title: 'Gramática Fundamental', class: '9ª Classe', date: '2025-01-12' },
// //       { title: 'Literatura Moçambicana', class: '10ª Classe', date: '2025-02-18' },
// //     ],
// //     'Ciências': [
// //       { title: 'Biologia Celular', class: '9ª Classe', date: '2025-01-15' },
// //       { title: 'Física Básica', class: '10ª Classe', date: '2025-02-20' },
// //     ],
// //     'História': [
// //       { title: 'História de Moçambique', class: '9ª Classe', date: '2025-01-20' },
// //     ],
// //     'Geografia': [
// //       { title: 'Geografia Física', class: '9ª Classe', date: '2025-01-25' },
// //     ],
// //   };

// //   const filteredContent = selectedSubject
// //     ? contentList[selectedSubject].filter((content) =>
// //         content.title.toLowerCase().includes(searchTerm.toLowerCase())
// //       )
// //     : [];

// //   return (
// //     <div>
// //     <Header/>

// //       {/* Seção Conteúdo */}
// //       <section className="content-section">
// //         <div className="container">
// //           <h2>Conteúdo Educacional</h2>
// //           <div className="search-bar">
// //             <input
// //               type="text"
// //               placeholder="Pesquisar conteúdos..."
// //               value={searchTerm}
// //               onChange={(e) => setSearchTerm(e.target.value)}
// //               disabled={!selectedSubject}
// //             />
// //           </div>

// //           {!selectedSubject ? (
// //             <div className="subject-cards">
// //               {subjects.map((subject) => (
// //                 <div
// //                   key={subject.name}
// //                   className="subject-card"
// //                   onClick={() => setSelectedSubject(subject.name)}
// //                 >
// //                   <img src={subject.icon} alt={subject.name} className="subject-icon" />
// //                   <h3>{subject.name}</h3>
// //                 </div>
// //               ))}
// //             </div>
// //           ) : (
// //             <div className="content-list-section">
// //               <button className="back-btn" onClick={() => setSelectedSubject(null)}>
// //                 Voltar
// //               </button>
// //               <h3>Conteúdos de {selectedSubject}</h3>
// //               {filteredContent.length > 0 ? (
// //                 <div className="content-list">
// //                   {filteredContent.map((content, index) => (
// //                     <div key={index} className="content-item">
// //                       <h4>{content.title}</h4>
// //                       <p>Classe: {content.class}</p>
// //                       <p>Data: {content.date}</p>
// //                     </div>
// //                   ))}
// //                 </div>
// //               ) : (
// //                 <p>Nenhum conteúdo encontrado para "{searchTerm}".</p>
// //               )}
// //             </div>
// //           )}
// //         </div>
// //       </section>

// //       {/* Footer */}
// //       <Footer />
// //     </div>
// //   );
// // };

// // export default ContentPage;



// import React, { useState } from 'react';
// import './ContentPage.css';
// import Footer from './Footer';
// import Header from './Header';
// import { Link } from 'react-router-dom'; // Importar Link para navegação

// const ContentPage = () => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null); // Novo estado para classe selecionada

//   const subjects = [
//     { name: 'Matemática', icon: '/images/math-icon.png' },
//     { name: 'Português', icon: '/images/portuguese-icon.png' },
//     { name: 'Ciências', icon: '/images/science-icon.png' },
//     { name: 'História', icon: '/images/history-icon.png' },
//     { name: 'Geografia', icon: '/images/geography-icon.png' },
//   ];

//   // Estrutura de dados atualizada com classes e temas
//   const contentList = {
//     'Matemática': {
//       '9ª Classe': [
//         { title: 'Álgebra Básica', date: '2025-01-10', id: 'algebra-basica' },
//         { title: 'Frações', date: '2025-01-15', id: 'fracoes' },
//       ],
//       '10ª Classe': [
//         { title: 'Geometria Plana', date: '2025-02-15', id: 'geometria-plana' },
//         { title: 'Equações Quadráticas', date: '2025-02-20', id: 'equacoes-quadraticas' },
//       ],
//       '11ª Classe': [
//         { title: 'Trigonometria', date: '2025-03-20', id: 'trigonometria' },
//       ],
//     },
//     'Português': {
//       '9ª Classe': [
//         { title: 'Gramática Fundamental', date: '2025-01-12', id: 'gramatica-fundamental' },
//       ],
//       '10ª Classe': [
//         { title: 'Literatura Moçambicana', date: '2025-02-18', id: 'literatura-mocambicana' },
//       ],
//     },
//     'Ciências': {
//       '9ª Classe': [
//         { title: 'Biologia Celular', date: '2025-01-15', id: 'biologia-celular' },
//       ],
//       '10ª Classe': [
//         { title: 'Física Básica', date: '2025-02-20', id: 'fisica-basica' },
//       ],
//     },
//     'História': {
//       '9ª Classe': [
//         { title: 'História de Moçambique', date: '2025-01-20', id: 'historia-mocambique' },
//       ],
//     },
//     'Geografia': {
//       '9ª Classe': [
//         { title: 'Geografia Física', date: '2025-01-25', id: 'geografia-fisica' },
//       ],
//     },
//   };

//   // Filtrar temas com base no termo de busca, se uma classe estiver selecionada
//   const filteredContent = selectedSubject && selectedClass
//     ? contentList[selectedSubject][selectedClass].filter((content) =>
//         content.title.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     : [];

//   return (
//     <div>
//       <Header />

//       {/* Seção Conteúdo */}
//       <section className="content-section">
//         <div className="container">
//           <h2>Conteúdo Educacional</h2>
//           <div className="search-bar">
//             <input
//               type="text"
//               placeholder="Pesquisar conteúdos..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               disabled={!selectedSubject || !selectedClass} // Desabilitar se nenhuma classe for selecionada
//             />
//           </div>

//           {!selectedSubject ? (
//             // Exibir disciplinas
//             <div className="subject-cards">
//               {subjects.map((subject) => (
//                 <div
//                   key={subject.name}
//                   className="subject-card"
//                   onClick={() => {
//                     setSelectedSubject(subject.name);
//                     setSelectedClass(null); // Resetar classe ao selecionar nova disciplina
//                     setSearchTerm(''); // Resetar busca
//                   }}
//                 >
//                   <img src={subject.icon} alt={subject.name} className="subject-icon" />
//                   <h3>{subject.name}</h3>
//                 </div>
//               ))}
//             </div>
//           ) : !selectedClass ? (
//             // Exibir classes da disciplina selecionada
//             <div className="class-list-section">
//               <button
//                 className="back-btn"
//                 onClick={() => {
//                   setSelectedSubject(null);
//                   setSearchTerm('');
//                 }}
//               >
//                 Voltar
//               </button>
//               <h3>Classes de {selectedSubject}</h3>
//               <div className="class-list">
//                 {Object.keys(contentList[selectedSubject]).map((className) => (
//                   <div
//                     key={className}
//                     className="class-item"
//                     onClick={() => setSelectedClass(className)}
//                   >
//                     <h4>{className}</h4>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ) : (
//             // Exibir temas da classe selecionada
//             <div className="content-list-section">
//               <button
//                 className="back-btn"
//                 onClick={() => {
//                   setSelectedClass(null);
//                   setSearchTerm('');
//                 }}
//               >
//                 Voltar
//               </button>
//               <h3>Conteúdos de {selectedSubject} - {selectedClass}</h3>
//               {filteredContent.length > 0 ? (
//                 <div className="content-list">
//                   {filteredContent.map((content) => (
//                     <Link
//                       key={content.id}
//                       to={`/read/${content.id}`} // Navegar para o ReadPage com o ID do tema
//                       className="content-item"
//                     >
//                       <h4>{content.title}</h4>
//                       <p>Data: {content.date}</p>
//                     </Link>
//                   ))}
//                 </div>
//               ) : (
//                 <p>Nenhum conteúdo encontrado para "{searchTerm}".</p>
//               )}
//             </div>
//           )}
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default ContentPage;

// HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH

// import React, { useState } from 'react';
// import './ContentPage.css';
// import Footer from './Footer';
// import Header from './Header';
// import { Link } from 'react-router-dom';

// // Exportar contentList para uso no ReadPage
// export const contentList = {
//   'Matemática': {
//     '9ª Classe': [
//       { title: 'Álgebra Básica', date: '2025-01-10', id: 'algebra-basica' },
//       { title: 'Frações', date: '2025-01-15', id: 'fracoes' },
//       { title: 'Números Inteiros', date: '2025-01-20', id: 'numeros-inteiros' },
//     ],
//     '10ª Classe': [
//       { title: 'Geometria Plana', date: '2025-02-15', id: 'geometria-plana' },
//       { title: 'Equações Quadráticas', date: '2025-02-20', id: 'equacoes-quadraticas' },
//       { title: 'Funções Lineares', date: '2025-02-25', id: 'funcoes-lineares' },
//     ],
//     '11ª Classe': [
//       { title: 'Trigonometria', date: '2025-03-20', id: 'trigonometria' },
//       { title: 'Matrizes', date: '2025-03-25', id: 'matrizes' },
//       { title: 'Probabilidade', date: '2025-03-30', id: 'probabilidade' },
//     ],
//   },
//   'Português': {
//     '9ª Classe': [
//       { title: 'Gramática Fundamental', date: '2025-01-12', id: 'gramatica-fundamental' },
//       { title: 'Ortografia e Pontuação', date: '2025-01-17', id: 'ortografia-pontuacao' },
//       { title: 'Leitura e Interpretação', date: '2025-01-22', id: 'leitura-interpretacao' },
//     ],
//     '10ª Classe': [
//       { title: 'Literatura Moçambicana', date: '2025-02-18', id: 'literatura-mocambicana' },
//       { title: 'Redação Narrativa', date: '2025-02-23', id: 'redacao-narrativa' },
//       { title: 'Análise de Textos', date: '2025-02-28', id: 'analise-textos' },
//     ],
//     '11ª Classe': [
//       { title: 'Literatura Portuguesa', date: '2025-03-10', id: 'literatura-portuguesa' },
//       { title: 'Redação Argumentativa', date: '2025-03-15', id: 'redacao-argumentativa' },
//       { title: 'Figuras de Linguagem', date: '2025-03-20', id: 'figuras-linguagem' },
//     ],
//   },
//   'Ciências': {
//     '9ª Classe': [
//       { title: 'Biologia Celular', date: '2025-01-15', id: 'biologia-celular' },
//       { title: 'Ecossistemas', date: '2025-01-20', id: 'ecossistemas' },
//       { title: 'Química Básica', date: '2025-01-25', id: 'quimica-basica' },
//     ],
//     '10ª Classe': [
//       { title: 'Física Básica', date: '2025-02-20', id: 'fisica-basica' },
//       { title: 'Reações Químicas', date: '2025-02-25', id: 'reacoes-quimicas' },
//       { title: 'Genética', date: '2025-02-28', id: 'genetica' },
//     ],
//     '11ª Classe': [
//       { title: 'Mecânica Clássica', date: '2025-03-15', id: 'mecanica-classica' },
//       { title: 'Química Orgânica', date: '2025-03-20', id: 'quimica-organica' },
//       { title: 'Evolução Biológica', date: '2025-03-25', id: 'evolucao-biologica' },
//     ],
//   },
//   'História': {
//     '9ª Classe': [
//       { title: 'História de Moçambique', date: '2025-01-20', id: 'historia-mocambique' },
//       { title: 'Civilizações Africanas', date: '2025-01-25', id: 'civilizacoes-africanas' },
//       { title: 'Colonização Europeia', date: '2025-01-30', id: 'colonizacao-europeia' },
//     ],
//     '10ª Classe': [
//       { title: 'Independência de Moçambique', date: '2025-02-15', id: 'independencia-mocambique' },
//       { title: 'Primeira Guerra Mundial', date: '2025-02-20', id: 'primeira-guerra-mundial' },
//       { title: 'Revoluções do Século XX', date: '2025-02-25', id: 'revolucoes-seculo-xx' },
//     ],
//     '11ª Classe': [
//       { title: 'Guerra Fria', date: '2025-03-10', id: 'guerra-fria' },
//       { title: 'História Contemporânea', date: '2025-03-15', id: 'historia-contemporanea' },
//       { title: 'Movimentos de Libertação', date: '2025-03-20', id: 'movimentos-libertacao' },
//     ],
//   },
//   'Geografia': {
//     '9ª Classe': [
//       { title: 'Geografia Física', date: '2025-01-25', id: 'geografia-fisica' },
//       { title: 'Climas do Mundo', date: '2025-01-30', id: 'climas-mundo' },
//       { title: 'Relevo Terrestre', date: '2025-02-05', id: 'relevo-terrestre' },
//     ],
//     '10ª Classe': [
//       { title: 'Geografia Humana', date: '2025-02-20', id: 'geografia-humana' },
//       { title: 'Urbanização', date: '2025-02-25', id: 'urbanizacao' },
//       { title: 'Recursos Naturais', date: '2025-03-01', id: 'recursos-naturais' },
//     ],
//     '11ª Classe': [
//       { title: 'Globalização', date: '2025-03-15', id: 'globalizacao' },
//       { title: 'Geopolítica', date: '2025-03-20', id: 'geopolitica' },
//       { title: 'Mudanças Climáticas', date: '2025-03-25', id: 'mudancas-climaticas' },
//     ],
//   },
// };

// const subjects = [
//   { name: 'Matemática', icon: '/images/math-icon.png' },
//   { name: 'Português', icon: '/images/portuguese-icon.png' },
//   { name: 'Ciências', icon: '/images/science-icon.png' },
//   { name: 'História', icon: '/images/history-icon.png' },
//   { name: 'Geografia', icon: '/images/geography-icon.png' },
// ];

// const ContentPage = () => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null);

//   const filteredContent = selectedSubject && selectedClass
//     ? contentList[selectedSubject][selectedClass].filter((content) =>
//         content.title.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     : [];

//   return (
//     <div>
//       <Header />
//       <section className="content-section">
//         <div className="container">
//           <h2>Conteúdo Educacional</h2>
//           <div className="search-bar">
//             <input
//               type="text"
//               placeholder="Pesquisar conteúdos..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               disabled={!selectedSubject || !selectedClass}
//             />
//           </div>

//           {!selectedSubject ? (
//             <div className="subject-cards">
//               {subjects.map((subject) => (
//                 <div
//                   key={subject.name}
//                   className="subject-card"
//                   onClick={() => {
//                     setSelectedSubject(subject.name);
//                     setSelectedClass(null);
//                     setSearchTerm('');
//                   }}
//                 >
//                   <img src={subject.icon} alt={subject.name} className="subject-icon" />
//                   <h3>{subject.name}</h3>
//                 </div>
//               ))}
//             </div>
//           ) : !selectedClass ? (
//             <div className="class-list-section">
//               <button
//                 className="back-btn"
//                 onClick={() => {
//                   setSelectedSubject(null);
//                   setSearchTerm('');
//                 }}
//               >
//                 Voltar
//               </button>
//               <h3>Classes de {selectedSubject}</h3>
//               <div className="class-list">
//                 {Object.keys(contentList[selectedSubject]).map((className) => (
//                   <div
//                     key={className}
//                     className="class-item"
//                     onClick={() => setSelectedClass(className)}
//                   >
//                     <h4>{className}</h4>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <div className="content-list-section">
//               <button
//                 className="back-btn"
//                 onClick={() => {
//                   setSelectedClass(null);
//                   setSearchTerm('');
//                 }}
//               >
//                 Voltar
//               </button>
//               <h3>Conteúdos de {selectedSubject} - {selectedClass}</h3>
//               {filteredContent.length > 0 ? (
//                 <div className="content-list">
//                   {filteredContent.map((content) => (
//                     <Link
//                       key={content.id}
//                       to={`/read/${content.id}`}
//                       className="content-item"
//                     >
//                       <h4>{content.title}</h4>
//                       <p>Data: {content.date}</p>
//                     </Link>
//                   ))}
//                 </div>
//               ) : (
//                 <p>Nenhum conteúdo encontrado para "{searchTerm}".</p>
//               )}
//             </div>
//           )}
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default ContentPage;

// HHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH

// import React, { useState } from 'react';
// import './ContentPage.css';
// import Footer from './Footer';
// import Header from './Header';
// import { Link } from 'react-router-dom';

// // Exportar contentList para uso no ReadPage
// export const contentList = {
//   'Matemática': {
//     '9ª Classe': [
//       { title: 'Álgebra Básica', date: '2025-01-10', id: 'algebra-basica' },
//       { title: 'Frações', date: '2025-01-15', id: 'fracoes' },
//       { title: 'Números Inteiros', date: '2025-01-20', id: 'numeros-inteiros' },
//     ],
//     '10ª Classe': [
//       { title: 'Geometria Plana', date: '2025-02-15', id: 'geometria-plana' },
//       { title: 'Equações Quadráticas', date: '2025-02-20', id: 'equacoes-quadraticas' },
//       { title: 'Funções Lineares', date: '2025-02-25', id: 'funcoes-lineares' },
//     ],
//     '11ª Classe': [
//       { title: 'Trigonometria', date: '2025-03-20', id: 'trigonometria' },
//       { title: 'Matrizes', date: '2025-03-25', id: 'matrizes' },
//       { title: 'Probabilidade', date: '2025-03-30', id: 'probabilidade' },
//     ],
//   },
//   'Português': {
//     '9ª Classe': [
//       { title: 'Gramática Fundamental', date: '2025-01-12', id: 'gramatica-fundamental' },
//       { title: 'Ortografia e Pontuação', date: '2025-01-17', id: 'ortografia-pontuacao' },
//       { title: 'Leitura e Interpretação', date: '2025-01-22', id: 'leitura-interpretacao' },
//     ],
//     '10ª Classe': [
//       { title: 'Literatura Moçambicana', date: '2025-02-18', id: 'literatura-mocambicana' },
//       { title: 'Redação Narrativa', date: '2025-02-23', id: 'redacao-narrativa' },
//       { title: 'Análise de Textos', date: '2025-02-28', id: 'analise-textos' },
//     ],
//     '11ª Classe': [
//       { title: 'Literatura Portuguesa', date: '2025-03-10', id: 'literatura-portuguesa' },
//       { title: 'Redação Argumentativa', date: '2025-03-15', id: 'redacao-argumentativa' },
//       { title: 'Figuras de Linguagem', date: '2025-03-20', id: 'figuras-linguagem' },
//     ],
//   },
//   'Ciências': {
//     '9ª Classe': [
//       { title: 'Biologia Celular', date: '2025-01-15', id: 'biologia-celular' },
//       { title: 'Ecossistemas', date: '2025-01-20', id: 'ecossistemas' },
//       { title: 'Química Básica', date: '2025-01-25', id: 'quimica-basica' },
//     ],
//     '10ª Classe': [
//       { title: 'Física Básica', date: '2025-02-20', id: 'fisica-basica' },
//       { title: 'Reações Químicas', date: '2025-02-25', id: 'reacoes-quimicas' },
//       { title: 'Genética', date: '2025-02-28', id: 'genetica' },
//     ],
//     '11ª Classe': [
//       { title: 'Mecânica Clássica', date: '2025-03-15', id: 'mecanica-classica' },
//       { title: 'Química Orgânica', date: '2025-03-20', id: 'quimica-organica' },
//       { title: 'Evolução Biológica', date: '2025-03-25', id: 'evolucao-biologica' },
//     ],
//   },
//   'História': {
//     '9ª Classe': [
//       { title: 'História de Moçambique', date: '2025-01-20', id: 'historia-mocambique' },
//       { title: 'Civilizações Africanas', date: '2025-01-25', id: 'civilizacoes-africanas' },
//       { title: 'Colonização Europeia', date: '2025-01-30', id: 'colonizacao-europeia' },
//     ],
//     '10ª Classe': [
//       { title: 'Independência de Moçambique', date: '2025-02-15', id: 'independencia-mocambique' },
//       { title: 'Primeira Guerra Mundial', date: '2025-02-20', id: 'primeira-guerra-mundial' },
//       { title: 'Revoluções do Século XX', date: '2025-02-25', id: 'revolucoes-seculo-xx' },
//     ],
//     '11ª Classe': [
//       { title: 'Guerra Fria', date: '2025-03-10', id: 'guerra-fria' },
//       { title: 'História Contemporânea', date: '2025-03-15', id: 'historia-contemporanea' },
//       { title: 'Movimentos de Libertação', date: '2025-03-20', id: 'movimentos-libertacao' },
//     ],
//   },
//   'Geografia': {
//     '9ª Classe': [
//       { title: 'Geografia Física', date: '2025-01-25', id: 'geografia-fisica' },
//       { title: 'Climas do Mundo', date: '2025-01-30', id: 'climas-mundo' },
//       { title: 'Relevo Terrestre', date: '2025-02-05', id: 'relevo-terrestre' },
//     ],
//     '10ª Classe': [
//       { title: 'Geografia Humana', date: '2025-02-20', id: 'geografia-humana' },
//       { title: 'Urbanização', date: '2025-02-25', id: 'urbanizacao' },
//       { title: 'Recursos Naturais', date: '2025-03-01', id: 'recursos-naturais' },
//     ],
//     '11ª Classe': [
//       { title: 'Globalização', date: '2025-03-15', id: 'globalizacao' },
//       { title: 'Geopolítica', date: '2025-03-20', id: 'geopolitica' },
//       { title: 'Mudanças Climáticas', date: '2025-03-25', id: 'mudancas-climaticas' },
//     ],
//   },
// };

// const subjects = [
//   { name: 'Matemática', icon: '/images/math-icon.png' },
//   { name: 'Português', icon: '/images/portuguese-icon.png' },
//   { name: 'Ciências', icon: '/images/science-icon.png' },
//   { name: 'História', icon: '/images/history-icon.png' },
//   { name: 'Geografia', icon: '/images/geography-icon.png' },
// ];

// const ContentPage = () => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null);

//   const filteredContent = selectedSubject && selectedClass
//     ? contentList[selectedSubject][selectedClass].filter((content) =>
//         content.title.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     : [];

//   return (
//     <div>
//       <Header />
//       <section className="content-section">
//         <div className="container">
//           <h2>Conteúdo Educacional</h2>
//           <div className="search-bar">
//             <input
//               type="text"
//               placeholder="Pesquisar conteúdos..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               disabled={!selectedSubject || !selectedClass}
//             />
//           </div>

//           {!selectedSubject ? (
//             <div className="subject-cards">
//               {subjects.map((subject) => (
//                 <div
//                   key={subject.name}
//                   className="subject-card"
//                   onClick={() => {
//                     setSelectedSubject(subject.name);
//                     setSelectedClass(null);
//                     setSearchTerm('');
//                   }}
//                 >
//                   <img src={subject.icon} alt={subject.name} className="subject-icon" />
//                   <h3>{subject.name}</h3>
//                 </div>
//               ))}
//             </div>
//           ) : !selectedClass ? (
//             <div className="class-list-section">
//               <button
//                 className="back-btn"
//                 onClick={() => {
//                   setSelectedSubject(null);
//                   setSearchTerm('');
//                 }}
//               >
//                 Voltar
//               </button>
//               <h3>Classes de {selectedSubject}</h3>
//               <div className="class-list">
//                 {Object.keys(contentList[selectedSubject]).map((className) => (
//                   <div
//                     key={className}
//                     className="class-item"
//                     onClick={() => setSelectedClass(className)}
//                   >
//                     <h4>{className}</h4>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <div className="content-list-section">
//               <button
//                 className="back-btn"
//                 onClick={() => {
//                   setSelectedClass(null);
//                   setSearchTerm('');
//                 }}
//               >
//                 Voltar
//               </button>
//               <h3>Conteúdos de {selectedSubject} - {selectedClass}</h3>
//               {filteredContent.length > 0 ? (
//                 <div className="content-list">
//                   {filteredContent.map((content) => (
//                     <Link
//                       key={content.id}
//                       to={`/read/${content.id.toLowerCase()}`}
//                       className="content-item"
//                     >
//                       <h4>{content.title}</h4>
//                       <p>Data: {content.date}</p>
//                     </Link>
//                   ))}
//                 </div>
//               ) : (
//                 <p>Nenhum conteúdo encontrado para "{searchTerm}".</p>
//               )}
//             </div>
//           )}
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default ContentPage;




// import React, { useState } from "react";
// import "./ContentPage.css";
// import Footer from "./Footer";
// import Header from "./Header";
// import { Link } from "react-router-dom";

// // Exportar contentList para uso no ReadPage
// export const contentList = {
//   Matemática: {
//     "9ª Classe": [
//       {
//         title: "Álgebra Básica",
//         date: "2025-01-10",
//         id: "algebra-basica",
//         content:
//           "O estudo da Álgebra Básica envolve expressões, equações e propriedades fundamentais dos números."
//       },
//       {
//         title: "Frações",
//         date: "2025-01-15",
//         id: "fracoes",
//         content:
//           "Frações representam partes de um todo. Nesta lição você aprenderá a simplificar, somar e multiplicar frações."
//       },
//       {
//         title: "Números Inteiros",
//         date: "2025-01-20",
//         id: "numeros-inteiros",
//         content:
//           "Os números inteiros incluem positivos, negativos e o zero. São utilizados em situações do dia a dia como temperaturas e dívidas."
//       }
//     ],
//     "10ª Classe": [
//       {
//         title: "Geometria Plana",
//         date: "2025-02-15",
//         id: "geometria-plana",
//         content:
//           "Geometria plana estuda figuras bidimensionais como triângulos, quadriláteros e circunferências."
//       },
//       {
//         title: "Equações Quadráticas",
//         date: "2025-02-20",
//         id: "equacoes-quadraticas",
//         content:
//           "Equações quadráticas são expressões do tipo ax²+bx+c=0. Aprenda a resolvê-las pelo método de Bhaskara."
//       }
//     ]
//   },

//   Português: {
//     "9ª Classe": [
//       {
//         title: "Gramática Fundamental",
//         date: "2025-01-12",
//         id: "gramatica-fundamental",
//         content:
//           "A gramática fundamental aborda classes de palavras, concordância e pontuação básica."
//       },
//       {
//         title: "Ortografia e Pontuação",
//         date: "2025-01-17",
//         id: "ortografia-pontuacao",
//         content:
//           "A ortografia trata da forma correta das palavras. Já a pontuação organiza e dá sentido ao texto."
//       }
//     ]
//   }
// };

// const ContentPage = () => {
//   const [selectedSubject, setSelectedSubject] = useState("Matemática");
//   const [selectedClass, setSelectedClass] = useState("9ª Classe");

//   const subjects = Object.keys(contentList);
//   const classes = Object.keys(contentList[selectedSubject]);

//   return (
//     <div>
//       <Header />

//       <div className="content-page">
//         <h1>Conteúdos</h1>

//         {/* Filtros */}
//         <div className="filters">
//           <select
//             value={selectedSubject}
//             onChange={(e) => setSelectedSubject(e.target.value)}
//           >
//             {subjects.map((subj) => (
//               <option key={subj} value={subj}>
//                 {subj}
//               </option>
//             ))}
//           </select>

//           <select
//             value={selectedClass}
//             onChange={(e) => setSelectedClass(e.target.value)}
//           >
//             {classes.map((cls) => (
//               <option key={cls} value={cls}>
//                 {cls}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Lista */}
//         <div className="content-list">
//           {contentList[selectedSubject][selectedClass].map((item) => (
//             <Link
//               key={item.id}
//               to={`/read/${selectedSubject}/${selectedClass}/${item.id}`}
//               className="content-item"
//             >
//               <h2>{item.title}</h2>
//               <p>{item.date}</p>
//             </Link>
//           ))}
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default ContentPage;




// JJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJ

// import React, { useState } from 'react';
// import './ContentPage.css';
// import Footer from './Footer';
// import Header from './Header';
// import { Link } from 'react-router-dom';

// // Exportar contentList para uso no ReadPage
// export const contentList = {
//   'Matemática': {
//     '9ª Classe': [
//       { title: 'Álgebra Básica', date: '2025-01-10', id: 'algebra-basica', content: 'Conteúdo sobre Álgebra Básica: Introdução aos conceitos fundamentais de álgebra, incluindo equações lineares e manipulação de variáveis.' },
//       { title: 'Frações', date: '2025-01-15', id: 'fracoes', content: 'Conteúdo sobre Frações: Aprenda operações com frações, simplificação e resolução de problemas práticos.' },
//       { title: 'Números Inteiros', date: '2025-01-20', id: 'numeros-inteiros', content: 'Conteúdo sobre Números Inteiros: Estudo das propriedades e operações com números inteiros.' },
//     ],
//     '10ª Classe': [
//       { title: 'Geometria Plana', date: '2025-02-15', id: 'geometria-plana', content: 'Conteúdo sobre Geometria Plana: Estudo de formas geométricas bidimensionais, como triângulos e círculos.' },
//       { title: 'Equações Quadráticas', date: '2025-02-20', id: 'equacoes-quadraticas', content: 'Conteúdo sobre Equações Quadráticas: Resolução de equações do segundo grau e suas aplicações.' },
//       { title: 'Funções Lineares', date: '2025-02-25', id: 'funcoes-lineares', content: 'Conteúdo sobre Funções Lineares: Introdução às funções lineares e suas representações gráficas.' },
//     ],
//     '11ª Classe': [
//       { title: 'Trigonometria', date: '2025-03-20', id: 'trigonometria', content: 'Conteúdo sobre Trigonometria: Funções trigonométricas e suas aplicações em cálculos geométricos.' },
//       { title: 'Matrizes', date: '2025-03-25', id: 'matrizes', content: 'Conteúdo sobre Matrizes: Operações com matrizes e suas aplicações em sistemas lineares.' },
//       { title: 'Probabilidade', date: '2025-03-30', id: 'probabilidade', content: 'Conteúdo sobre Probabilidade: Conceitos básicos de probabilidade e eventos aleatórios.' },
//     ],
//   },
//   'Português': {
//     '9ª Classe': [
//       { title: 'Gramática Fundamental', date: '2025-01-12', id: 'gramatica-fundamental', content: 'Conteúdo sobre Gramática Fundamental: Regras básicas de gramática portuguesa, incluindo concordância e regência.' },
//       { title: 'Ortografia e Pontuação', date: '2025-01-17', id: 'ortografia-pontuacao', content: 'Conteúdo sobre Ortografia e Pontuação: Regras de escrita correta e uso de sinais de pontuação.' },
//       { title: 'Leitura e Interpretação', date: '2025-01-22', id: 'leitura-interpretacao', content: 'Conteúdo sobre Leitura e Interpretação: Técnicas para compreender e analisar textos diversos.' },
//     ],
//     '10ª Classe': [
//       { title: 'Literatura Moçambicana', date: '2025-02-18', id: 'literatura-mocambicana', content: 'Conteúdo sobre Literatura Moçambicana: Estudo de autores e obras representativas de Moçambique.' },
//       { title: 'Redação Narrativa', date: '2025-02-23', id: 'redacao-narrativa', content: 'Conteúdo sobre Redação Narrativa: Estrutura e técnicas para escrever textos narrativos.' },
//       { title: 'Análise de Textos', date: '2025-02-28', id: 'analise-textos', content: 'Conteúdo sobre Análise de Textos: Métodos para interpretar e criticar textos literários e não literários.' },
//     ],
//     '11ª Classe': [
//       { title: 'Literatura Portuguesa', date: '2025-03-10', id: 'literatura-portuguesa', content: 'Conteúdo sobre Literatura Portuguesa: Estudo de autores clássicos e contemporâneos de Portugal.' },
//       { title: 'Redação Argumentativa', date: '2025-03-15', id: 'redacao-argumentativa', content: 'Conteúdo sobre Redação Argumentativa: Técnicas para construir argumentos sólidos em textos dissertativos.' },
//       { title: 'Figuras de Linguagem', date: '2025-03-20', id: 'figuras-linguagem', content: 'Conteúdo sobre Figuras de Linguagem: Identificação e uso de recursos estilísticos na língua portuguesa.' },
//     ],
//   },
//   'Ciências': {
//     '9ª Classe': [
//       { title: 'Biologia Celular', date: '2025-01-15', id: 'biologia-celular', content: 'Conteúdo sobre Biologia Celular: Estrutura e função das células, incluindo organelas e processos celulares.' },
//       { title: 'Ecossistemas', date: '2025-01-20', id: 'ecossistemas', content: 'Conteúdo sobre Ecossistemas: Interações entre organismos e o ambiente em diferentes ecossistemas.' },
//       { title: 'Química Básica', date: '2025-01-25', id: 'quimica-basica', content: 'Conteúdo sobre Química Básica: Conceitos fundamentais de átomos, moléculas e reações químicas.' },
//     ],
//     '10ª Classe': [
//       { title: 'Física Básica', date: '2025-02-20', id: 'fisica-basica', content: 'Conteúdo sobre Física Básica: Conceitos fundamentais de mecânica e energia.' },
//       { title: 'Reações Químicas', date: '2025-02-25', id: 'reacoes-quimicas', content: 'Conteúdo sobre Reações Químicas: Tipos de reações e balanceamento de equações químicas.' },
//       { title: 'Genética', date: '2025-02-28', id: 'genetica', content: 'Conteúdo sobre Genética: Princípios de hereditariedade e leis de Mendel.' },
//     ],
//     '11ª Classe': [
//       { title: 'Mecânica Clássica', date: '2025-03-15', id: 'mecanica-classica', content: 'Conteúdo sobre Mecânica Clássica: Leis de Newton e suas aplicações.' },
//       { title: 'Química Orgânica', date: '2025-03-20', id: 'quimica-organica', content: 'Conteúdo sobre Química Orgânica: Introdução aos compostos orgânicos e suas propriedades.' },
//       { title: 'Evolução Biológica', date: '2025-03-25', id: 'evolucao-biologica', content: 'Conteúdo sobre Evolução Biológica: Teoria da evolução e seleção natural.' },
//     ],
//   },
//   'História': {
//     '9ª Classe': [
//       { title: 'História de Moçambique', date: '2025-01-20', id: 'historia-mocambique', content: 'Conteúdo sobre História de Moçambique: Eventos históricos e sua relevância para o país.' },
//       { title: 'Civilizações Africanas', date: '2025-01-25', id: 'civilizacoes-africanas', content: 'Conteúdo sobre Civilizações Africanas: Estudo das grandes civilizações pré-coloniais da África.' },
//       { title: 'Colonização Europeia', date: '2025-01-30', id: 'colonizacao-europeia', content: 'Conteúdo sobre Colonização Europeia: Impactos da colonização em África e Moçambique.' },
//     ],
//     '10ª Classe': [
//       { title: 'Independência de Moçambique', date: '2025-02-15', id: 'independencia-mocambique', content: 'Conteúdo sobre Independência de Moçambique: Processo de luta pela independência e seus desdobramentos.' },
//       { title: 'Primeira Guerra Mundial', date: '2025-02-20', id: 'primeira-guerra-mundial', content: 'Conteúdo sobre Primeira Guerra Mundial: Causas, eventos e consequências globais.' },
//       { title: 'Revoluções do Século XX', date: '2025-02-25', id: 'revolucoes-seculo-xx', content: 'Conteúdo sobre Revoluções do Século XX: Estudo das revoluções que marcaram o século passado.' },
//     ],
//     '11ª Classe': [
//       { title: 'Guerra Fria', date: '2025-03-10', id: 'guerra-fria', content: 'Conteúdo sobre Guerra Fria: Conflitos ideológicos e geopolíticos entre EUA e URSS.' },
//       { title: 'História Contemporânea', date: '2025-03-15', id: 'historia-contemporanea', content: 'Conteúdo sobre História Contemporânea: Eventos globais do final do século XX e início do XXI.' },
//       { title: 'Movimentos de Libertação', date: '2025-03-20', id: 'movimentos-libertacao', content: 'Conteúdo sobre Movimentos de Libertação: Lutas anticoloniais na África e no mundo.' },
//     ],
//   },
//   'Geografia': {
//     '9ª Classe': [
//       { title: 'Geografia Física', date: '2025-01-25', id: 'geografia-fisica', content: 'Conteúdo sobre Geografia Física: Estudo dos fenômenos naturais e paisagens.' },
//       { title: 'Climas do Mundo', date: '2025-01-30', id: 'climas-mundo', content: 'Conteúdo sobre Climas do Mundo: Classificação e características dos climas globais.' },
//       { title: 'Relevo Terrestre', date: '2025-02-05', id: 'relevo-terrestre', content: 'Conteúdo sobre Relevo Terrestre: Formação e tipos de relevo na superfície terrestre.' },
//     ],
//     '10ª Classe': [
//       { title: 'Geografia Humana', date: '2025-02-20', id: 'geografia-humana', content: 'Conteúdo sobre Geografia Humana: Dinâmicas populacionais e atividades econômicas.' },
//       { title: 'Urbanização', date: '2025-02-25', id: 'urbanizacao', content: 'Conteúdo sobre Urbanização: Crescimento das cidades e seus desafios.' },
//       { title: 'Recursos Naturais', date: '2025-03-01', id: 'recursos-naturais', content: 'Conteúdo sobre Recursos Naturais: Uso e conservação dos recursos naturais.' },
//     ],
//     '11ª Classe': [
//       { title: 'Globalização', date: '2025-03-15', id: 'globalizacao', content: 'Conteúdo sobre Globalização: Impactos econômicos, culturais e sociais da globalização.' },
//       { title: 'Geopolítica', date: '2025-03-20', id: 'geopolitica', content: 'Conteúdo sobre Geopolítica: Relações de poder entre nações e conflitos globais.' },
//       { title: 'Mudanças Climáticas', date: '2025-03-25', id: 'mudancas-climaticas', content: 'Conteúdo sobre Mudanças Climáticas: Causas, efeitos e estratégias de mitigação.' },
//     ],
//   },
// };

// const subjects = [
//   { name: 'Matemática', icon: '/images/math-icon.png' },
//   { name: 'Português', icon: '/images/portuguese-icon.png' },
//   { name: 'Ciências', icon: '/images/science-icon.png' },
//   { name: 'História', icon: '/images/history-icon.png' },
//   { name: 'Geografia', icon: '/images/geography-icon.png' },
// ];

// const ContentPage = () => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [selectedClass, setSelectedClass] = useState(null);

//   const filteredContent = selectedSubject && selectedClass
//     ? contentList[selectedSubject][selectedClass].filter((content) =>
//         content.title.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     : [];

//   return (
//     <div>
//       <Header />
//       <section className="content-section">
//         <div className="container">
//           <h2>Conteúdo Educacional</h2>
//           <div className="search-bar">
//             <input
//               type="text"
//               placeholder="Pesquisar conteúdos..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               disabled={!selectedSubject || !selectedClass}
//             />
//           </div>

//           {!selectedSubject ? (
//             <div className="subject-cards">
//               {subjects.map((subject) => (
//                 <div
//                   key={subject.name}
//                   className="subject-card"
//                   onClick={() => {
//                     setSelectedSubject(subject.name);
//                     setSelectedClass(null);
//                     setSearchTerm('');
//                   }}
//                 >
//                   <img src={subject.icon} alt={subject.name} className="subject-icon" />
//                   <h3>{subject.name}</h3>
//                 </div>
//               ))}
//             </div>
//           ) : !selectedClass ? (
//             <div className="class-list-section">
//               <button
//                 className="back-btn"
//                 onClick={() => {
//                   setSelectedSubject(null);
//                   setSearchTerm('');
//                 }}
//               >
//                 Voltar
//               </button>
//               <h3>Classes de {selectedSubject}</h3>
//               <div className="class-list">
//                 {Object.keys(contentList[selectedSubject]).map((className) => (
//                   <div
//                     key={className}
//                     className="class-item"
//                     onClick={() => setSelectedClass(className)}
//                   >
//                     <h4>{className}</h4>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <div className="content-list-section">
//               <button
//                 className="back-btn"
//                 onClick={() => {
//                   setSelectedClass(null);
//                   setSearchTerm('');
//                 }}
//               >
//                 Voltar
//               </button>
//               <h3>Conteúdos de {selectedSubject} - {selectedClass}</h3>
//               {filteredContent.length > 0 ? (
//                 <div className="content-list">
//                   {filteredContent.map((content) => (
//                     <Link
//                       key={content.id}
//                       to={`/read/${content.id}`}
//                       className="content-item"
//                     >
//                       <h4>{content.title}</h4>
//                       <p>Data: {content.date}</p>
//                     </Link>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="content-list">
//                   {contentList[selectedSubject][selectedClass].map((content) => (
//                     <Link
//                       key={content.id}
//                       to={`/read/${content.id}`}
//                       className="content-item"
//                     >
//                       <h4>{content.title}</h4>
//                       <p>Data: {content.date}</p>
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default ContentPage;




import React, { useState, useEffect } from 'react';
import './ContentPage.css';
import Footer from './Footer';
import Header from './Header';
import { Link, useParams } from 'react-router-dom';
import classroomImage from '../as.avif';

// Exportar contentList para uso em outras páginas se necessário
export const contentList = {
  'Matemática': {
    '9ª Classe': [
      { title: 'Álgebra Básica', date: '2025-01-10', id: 'algebra-basica', content: 'Conteúdo sobre Álgebra Básica: Introdução aos conceitos fundamentais de álgebra, incluindo equações lineares e manipulação de variáveis.' },
      { title: 'Frações', date: '2025-01-15', id: 'fracoes', content: 'Conteúdo sobre Frações: Aprenda operações com frações, simplificação e resolução de problemas práticos.' },
      { title: 'Números Inteiros', date: '2025-01-20', id: 'numeros-inteiros', content: 'Conteúdo sobre Números Inteiros: Estudo das propriedades e operações com números inteiros.' },
    ],
    '10ª Classe': [
      { title: 'Geometria Plana', date: '2025-02-15', id: 'geometria-plana', content: 'Conteúdo sobre Geometria Plana: Estudo de formas geométricas bidimensionais, como triângulos e círculos.' },
      { title: 'Equações Quadráticas', date: '2025-02-20', id: 'equacoes-quadraticas', content: 'Conteúdo sobre Equações Quadráticas: Resolução de equações do segundo grau e suas aplicações.' },
      { title: 'Funções Lineares', date: '2025-02-25', id: 'funcoes-lineares', content: 'Conteúdo sobre Funções Lineares: Introdução às funções lineares e suas representações gráficas.' },
    ],
    '11ª Classe': [
      { title: 'Trigonometria', date: '2025-03-20', id: 'trigonometria', content: 'Conteúdo sobre Trigonometria: Funções trigonométricas e suas aplicações em cálculos geométricos.' },
      { title: 'Matrizes', date: '2025-03-25', id: 'matrizes', content: 'Conteúdo sobre Matrizes: Operações com matrizes e suas aplicações em sistemas lineares.' },
      { title: 'Probabilidade', date: '2025-03-30', id: 'probabilidade', content: 'Conteúdo sobre Probabilidade: Conceitos básicos de probabilidade e eventos aleatórios.' },
    ],
  },
  'Português': {
    '9ª Classe': [
      { title: 'Gramática Fundamental', date: '2025-01-12', id: 'gramatica-fundamental', content: 'Conteúdo sobre Gramática Fundamental: Regras básicas de gramática portuguesa, incluindo concordância e regência.' },
      { title: 'Ortografia e Pontuação', date: '2025-01-17', id: 'ortografia-pontuacao', content: 'Conteúdo sobre Ortografia e Pontuação: Regras de escrita correta e uso de sinais de pontuação.' },
      { title: 'Leitura e Interpretação', date: '2025-01-22', id: 'leitura-interpretacao', content: 'Conteúdo sobre Leitura e Interpretação: Técnicas para compreender e analisar textos diversos.' },
    ],
    '10ª Classe': [
      { title: 'Literatura Moçambicana', date: '2025-02-18', id: 'literatura-mocambicana', content: 'Conteúdo sobre Literatura Moçambicana: Estudo de autores e obras representativas de Moçambique.' },
      { title: 'Redação Narrativa', date: '2025-02-23', id: 'redacao-narrativa', content: 'Conteúdo sobre Redação Narrativa: Estrutura e técnicas para escrever textos narrativos.' },
      { title: 'Análise de Textos', date: '2025-02-28', id: 'analise-textos', content: 'Conteúdo sobre Análise de Textos: Métodos para interpretar e criticar textos literários e não literários.' },
    ],
    '11ª Classe': [
      { title: 'Literatura Portuguesa', date: '2025-03-10', id: 'literatura-portuguesa', content: 'Conteúdo sobre Literatura Portuguesa: Estudo de autores clássicos e contemporâneos de Portugal.' },
      { title: 'Redação Argumentativa', date: '2025-03-15', id: 'redacao-argumentativa', content: 'Conteúdo sobre Redação Argumentativa: Técnicas para construir argumentos sólidos em textos dissertativos.' },
      { title: 'Figuras de Linguagem', date: '2025-03-20', id: 'figuras-linguagem', content: 'Conteúdo sobre Figuras de Linguagem: Identificação e uso de recursos estilísticos na língua portuguesa.' },
    ],
  },
  'Ciências': {
    '9ª Classe': [
      { title: 'Biologia Celular', date: '2025-01-15', id: 'biologia-celular', content: 'Conteúdo sobre Biologia Celular: Estrutura e função das células, incluindo organelas e processos celulares.' },
      { title: 'Ecossistemas', date: '2025-01-20', id: 'ecossistemas', content: 'Conteúdo sobre Ecossistemas: Interações entre organismos e o ambiente em diferentes ecossistemas.' },
      { title: 'Química Básica', date: '2025-01-25', id: 'quimica-basica', content: 'Conteúdo sobre Química Básica: Conceitos fundamentais de átomos, moléculas e reações químicas.' },
    ],
    '10ª Classe': [
      { title: 'Física Básica', date: '2025-02-20', id: 'fisica-basica', content: 'Conteúdo sobre Física Básica: Conceitos fundamentais de mecânica e energia.' },
      { title: 'Reações Químicas', date: '2025-02-25', id: 'reacoes-quimicas', content: 'Conteúdo sobre Reações Químicas: Tipos de reações e balanceamento de equações químicas.' },
      { title: 'Genética', date: '2025-02-28', id: 'genetica', content: 'Conteúdo sobre Genética: Princípios de hereditariedade e leis de Mendel.' },
    ],
    '11ª Classe': [
      { title: 'Mecânica Clássica', date: '2025-03-15', id: 'mecanica-classica', content: 'Conteúdo sobre Mecânica Clássica: Leis de Newton e suas aplicações.' },
      { title: 'Química Orgânica', date: '2025-03-20', id: 'quimica-organica', content: 'Conteúdo sobre Química Orgânica: Introdução aos compostos orgânicos e suas propriedades.' },
      { title: 'Evolução Biológica', date: '2025-03-25', id: 'evolucao-biologica', content: 'Conteúdo sobre Evolução Biológica: Teoria da evolução e seleção natural.' },
    ],
  },
  'História': {
    '9ª Classe': [
      { title: 'História de Moçambique', date: '2025-01-20', id: 'historia-mocambique', content: 'Conteúdo sobre História de Moçambique: Eventos históricos e sua relevância para o país.' },
      { title: 'Civilizações Africanas', date: '2025-01-25', id: 'civilizacoes-africanas', content: 'Conteúdo sobre Civilizações Africanas: Estudo das grandes civilizações pré-coloniais da África.' },
      { title: 'Colonização Europeia', date: '2025-01-30', id: 'colonizacao-europeia', content: 'Conteúdo sobre Colonização Europeia: Impactos da colonização em África e Moçambique.' },
    ],
    '10ª Classe': [
      { title: 'Independência de Moçambique', date: '2025-02-15', id: 'independencia-mocambique', content: 'Conteúdo sobre Independência de Moçambique: Processo de luta pela independência e seus desdobramentos.' },
      { title: 'Primeira Guerra Mundial', date: '2025-02-20', id: 'primeira-guerra-mundial', content: 'Conteúdo sobre Primeira Guerra Mundial: Causas, eventos e consequências globais.' },
      { title: 'Revoluções do Século XX', date: '2025-02-25', id: 'revolucoes-seculo-xx', content: 'Conteúdo sobre Revoluções do Século XX: Estudo das revoluções que marcaram o século passado.' },
    ],
    '11ª Classe': [
      { title: 'Guerra Fria', date: '2025-03-10', id: 'guerra-fria', content: 'Conteúdo sobre Guerra Fria: Conflitos ideológicos e geopolíticos entre EUA e URSS.' },
      { title: 'História Contemporânea', date: '2025-03-15', id: 'historia-contemporanea', content: 'Conteúdo sobre História Contemporânea: Eventos globais do final do século XX e início do XXI.' },
      { title: 'Movimentos de Libertação', date: '2025-03-20', id: 'movimentos-libertacao', content: 'Conteúdo sobre Movimentos de Libertação: Lutas anticoloniais na África e no mundo.' },
    ],
  },
  'Geografia': {
    '9ª Classe': [
      { title: 'Geografia Física', date: '2025-01-25', id: 'geografia-fisica', content: 'Conteúdo sobre Geografia Física: Estudo dos fenômenos naturais e paisagens.' },
      { title: 'Climas do Mundo', date: '2025-01-30', id: 'climas-mundo', content: 'Conteúdo sobre Climas do Mundo: Classificação e características dos climas globais.' },
      { title: 'Relevo Terrestre', date: '2025-02-05', id: 'relevo-terrestre', content: 'Conteúdo sobre Relevo Terrestre: Formação e tipos de relevo na superfície terrestre.' },
    ],
    '10ª Classe': [
      { title: 'Geografia Humana', date: '2025-02-20', id: 'geografia-humana', content: 'Conteúdo sobre Geografia Humana: Dinâmicas populacionais e atividades econômicas.' },
      { title: 'Urbanização', date: '2025-02-25', id: 'urbanizacao', content: 'Conteúdo sobre Urbanização: Crescimento das cidades e seus desafios.' },
      { title: 'Recursos Naturais', date: '2025-03-01', id: 'recursos-naturais', content: 'Conteúdo sobre Recursos Naturais: Uso e conservação dos recursos naturais.' },
    ],
    '11ª Classe': [
      { title: 'Globalização', date: '2025-03-15', id: 'globalizacao', content: 'Conteúdo sobre Globalização: Impactos econômicos, culturais e sociais da globalização.' },
      { title: 'Geopolítica', date: '2025-03-20', id: 'geopolitica', content: 'Conteúdo sobre Geopolítica: Relações de poder entre nações e conflitos globais.' },
      { title: 'Mudanças Climáticas', date: '2025-03-25', id: 'mudancas-climaticas', content: 'Conteúdo sobre Mudanças Climáticas: Causas, efeitos e estratégias de mitigação.' },
    ],
  },
};

const subjects = [
  { name: 'Matemática', icon: '/images/math-icon.png' },
  { name: 'Português', icon: '/images/portuguese-icon.png' },
  { name: 'Ciências', icon: '/images/science-icon.png' },
  { name: 'História', icon: '/images/history-icon.png' },
  { name: 'Geografia', icon: '/images/geography-icon.png' },
];

const ContentPage = () => {
  const { contentId } = useParams();
  const normalizedId = contentId ? contentId.toLowerCase() : null;
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [fontSize, setFontSize] = useState(16);
  const [isBionic, setIsBionic] = useState(false);
  const [isReading, setIsReading] = useState(false);
  const [voiceSpeed, setVoiceSpeed] = useState(1);
  const [voiceGender, setVoiceGender] = useState('female');
  const [voiceLang, setVoiceLang] = useState('pt-BR');
  const [voices, setVoices] = useState([]);

  let currentTopic = null;
  let currentSubject = null;
  let currentClass = null;
  let relatedTopics = [];

  // Procurar conteúdo pelo ID
  if (normalizedId && contentList) {
    Object.entries(contentList).forEach(([subject, classes]) => {
      Object.entries(classes).forEach(([className, topics]) => {
        const found = topics.find((topic) => topic.id.toLowerCase() === normalizedId);
        if (found) {
          currentTopic = found;
          currentSubject = subject;
          currentClass = className;
          relatedTopics = topics.filter((t) => t.id.toLowerCase() !== normalizedId).slice(0, 2);
        }
      });
    });
  }

  // Filtrar conteúdos
  const filteredContent = selectedSubject && selectedClass
    ? contentList[selectedSubject][selectedClass].filter((content) =>
        content.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  // Conteúdo principal
  const textContent = currentTopic
    ? currentTopic.content
    : null;

  // Leitura por voz
  useEffect(() => {
    const loadVoices = () => {
      const availableVoices = window.speechSynthesis.getVoices();
      setVoices(availableVoices);
    };

    loadVoices();
    window.speechSynthesis.onvoiceschanged = loadVoices;

    return () => {
      window.speechSynthesis.onvoiceschanged = null;
    };
  }, []);

  const toggleVoiceReading = () => {
    if (!textContent) return;
    if (isReading) {
      window.speechSynthesis.cancel();
      setIsReading(false);
    } else {
      const utterance = new SpeechSynthesisUtterance(textContent);
      utterance.lang = voiceLang;
      utterance.rate = voiceSpeed;

      const genderKeyword = voiceGender === 'female' ? 'female' : 'male';
      let selectedVoice = voices.find((voice) =>
        voice.lang === voiceLang && voice.name.toLowerCase().includes(genderKeyword)
      );
      if (!selectedVoice) {
        selectedVoice = voices.find((voice) => voice.lang === voiceLang);
      }
      if (selectedVoice) {
        utterance.voice = selectedVoice;
      }

      window.speechSynthesis.speak(utterance);
      setIsReading(true);

      utterance.onend = () => setIsReading(false);
    }
  };

  // Leitura biônica
  const applyBionicReading = (text) => {
    if (!isBionic || !text) return text;
    return text.split(' ').map((word, index) => {
      const midPoint = Math.ceil(word.length / 2);
      return (
        <span key={index}>
          <b>{word.slice(0, midPoint)}</b>
          {word.slice(midPoint)}{' '}
        </span>
      );
    });
  };

  return (
    <div>
      <Header />
      <section className="content-section">
        <div className="container">
          {!normalizedId ? (
            <>
              <h2>Conteúdo Educacional</h2>
              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Pesquisar conteúdos..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  disabled={!selectedSubject || !selectedClass}
                />
              </div>

              {!selectedSubject ? (
                <div className="subject-cards">
                  {subjects.map((subject) => (
                    <div
                      key={subject.name}
                      className="subject-card"
                      onClick={() => {
                        setSelectedSubject(subject.name);
                        setSelectedClass(null);
                        setSearchTerm('');
                      }}
                    >
                      <img src={subject.icon} alt={subject.name} className="subject-icon" />
                      <h3>{subject.name}</h3>
                    </div>
                  ))}
                </div>
              ) : !selectedClass ? (
                <div className="class-list-section">
                  <button
                    className="back-btn"
                    onClick={() => {
                      setSelectedSubject(null);
                      setSearchTerm('');
                    }}
                  >
                    Voltar
                  </button>
                  <h3>Classes de {selectedSubject}</h3>
                  <div className="class-list">
                    {Object.keys(contentList[selectedSubject]).map((className) => (
                      <div
                        key={className}
                        className="class-item"
                        onClick={() => setSelectedClass(className)}
                      >
                        <h4>{className}</h4>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="content-list-section">
                  <button
                    className="back-btn"
                    onClick={() => {
                      setSelectedClass(null);
                      setSearchTerm('');
                    }}
                  >
                    Voltar
                  </button>
                  <h3>Conteúdos de {selectedSubject} - {selectedClass}</h3>
                  <div className="content-list">
                    {filteredContent.length > 0 ? (
                      filteredContent.map((content) => (
                        <Link
                          key={content.id}
                          to={`/content/${content.id}`}
                          className="content-item"
                        >
                          <h4>{content.title}</h4>
                          <p>Data: {content.date}</p>
                        </Link>
                      ))
                    ) : (
                      contentList[selectedSubject][selectedClass].map((content) => (
                        <Link
                          key={content.id}
                          to={`/content/${content.id}`}
                          className="content-item"
                        >
                          <h4>{content.title}</h4>
                          <p>Data: {content.date}</p>
                        </Link>
                      ))
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="read-page-container">
              <div className="header-image">
                <img src={classroomImage} alt="Classroom" />
              </div>

              {/* Controles */}
              <div className="controls">
                <div className="font-size-controls">
                  <button onClick={() => setFontSize((s) => Math.min(s + 2, 32))} className="control-btn">
                    Aumentar
                  </button>
                  <button onClick={() => setFontSize((s) => Math.max(s - 2, 12))} className="control-btn">
                    Diminuir
                  </button>
                </div>
                <button onClick={() => setIsBionic(!isBionic)} className="control-btn">
                  {isBionic ? 'Desativar Biónico' : 'Ativar Biónico'}
                </button>
                <div className="voice-controls">
                  <button onClick={toggleVoiceReading} className="control-btn">
                    {isReading ? 'Parar Voz' : 'Ler por Voz'}
                  </button>
                  <div className="voice-options">
                    <select value={voiceSpeed} onChange={(e) => setVoiceSpeed(parseFloat(e.target.value))}>
                      <option value={0.5}>Lento</option>
                      <option value={1}>Normal</option>
                      <option value={1.5}>Rápido</option>
                    </select>
                    <select value={voiceGender} onChange={(e) => setVoiceGender(e.target.value)}>
                      <option value="female">Feminina</option>
                      <option value="male">Masculina</option>
                    </select>
                    <select value={voiceLang} onChange={(e) => setVoiceLang(e.target.value)}>
                      <option value="pt-BR">Português</option>
                      <option value="en-US">Inglês</option>
                    </select>
                  </div>
                </div>
                <button
                  className="back-btn"
                  onClick={() => window.history.back()}
                >
                  Voltar
                </button>
              </div>

              {/* Conteúdo */}
              <div className="content">
                <h1>
                  {currentTopic?.title ||
                    (normalizedId ? normalizedId.replace(/-/g, ' ').toUpperCase() : 'Conteúdo')}
                </h1>
                <p style={{ fontSize: `${fontSize}px` }} className="main-text">
                  {applyBionicReading(textContent || 'Conteúdo não encontrado.')}
                </p>
                <div className="author">
                  <span>
                    Disciplina: {currentSubject || 'N/A'} | Classe: {currentClass || 'N/A'}
                  </span>
                </div>
              </div>

              {/* Relacionados */}
              <div className="related-blogs">
                <h2>Temas Relacionados</h2>
                <div className="blog-posts">
                  {relatedTopics.length > 0 ? (
                    relatedTopics.map((topic) => (
                      <Link key={topic.id} to={`/content/${topic.id}`} className="blog-post">
                        <h3>{topic.title}</h3>
                        <p>Data: {topic.date}</p>
                        <span className="read-more">Ler Mais</span>
                      </Link>
                    ))
                  ) : (
                    <p>Nenhum tema relacionado disponível.</p>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ContentPage;